import { get } from 'src/api/api';

import { useMutation, useQuery } from '@tanstack/react-query';
import { clientConfig } from 'src/api/axios/config';

const URI = 'config';

export interface ConfigAuth {
  client: string;
  clientId: string;
  domain: string;
  platform: string;
}

const useGetConfigAuth = () => {
  const hostname = window.location.hostname;
  const subdomain = hostname.split('.')[0];

  return useQuery({
    queryKey: [URI, subdomain],
    queryFn: async () => {
      const response = await get<ConfigAuth>({ uri: `${URI}/auth/${subdomain}` });
      clientConfig.setPlatform(response.data.platform);
      return response.data;
    },
    retry: 1,
    staleTime: 1000 * 60,
  });
};

const useGetConfigAuthByClient = () => {
  return useMutation({
    mutationFn: async (client?: string) => {
      if (!client) {
        return;
      }

      const response = await get<ConfigAuth>({ uri: `${URI}/auth/${client}` });
      return response.data;
    },
  });
};

export { useGetConfigAuth, useGetConfigAuthByClient };
